module.exports = __webpack_public_path__ + "img/app_icon_map_room.e0fcb480.png";